<template>
  <section
    v-if="highlights.length > 0"
    id="tag-highlights"
    class="highlights-section"
  >
    <div class="highlights-title tour-description-heading">
      <h2 class="highlights-title-heading">Highlights</h2>
    </div>
    <div class="highlights-content" v-html="highlights"></div>
  </section>
</template>
<script>
export default {
  name: "TourHighlight",
  props: {
    highlights: String
  }
};
</script>
